import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const TaskModule = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="7" y="8.5" width="10" height="1" rx="0.5" fill="#E8E8E8" />
          <rect x="7" y="11.5" width="10" height="1" rx="0.5" fill="#E8E8E8" />
          <rect x="7" y="14.5" width="7" height="1" rx="0.5" fill="#E8E8E8" />
          <rect
            x="3"
            y="4"
            width="18"
            height="16"
            rx="1.6696"
            fill="url(#paint0_linear_123_14419)"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.35355 8.14645C9.54882 8.34171 9.54882 8.65829 9.35355 8.85355L7.49497 10.7121C7.22161 10.9855 6.77839 10.9855 6.50503 10.7121L5.64645 9.85355C5.45118 9.65829 5.45118 9.34171 5.64645 9.14645C5.84171 8.95118 6.15829 8.95118 6.35355 9.14645L7 9.79289L8.64645 8.14645C8.84171 7.95118 9.15829 7.95118 9.35355 8.14645Z"
            fill="#263E00"
          />
          <rect x="11" y="9" width="7" height="1" rx="0.5" fill="#263E00" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.35355 13.1464C9.54882 13.3417 9.54882 13.6583 9.35355 13.8536L7.49497 15.7121C7.22161 15.9855 6.77839 15.9855 6.50503 15.7121L5.64645 14.8536C5.45118 14.6583 5.45118 14.3417 5.64645 14.1464C5.84171 13.9512 6.15829 13.9512 6.35355 14.1464L7 14.7929L8.64645 13.1464C8.84171 12.9512 9.15829 12.9512 9.35355 13.1464Z"
            fill="#263E00"
          />
          <rect x="11" y="14" width="7" height="1" rx="0.5" fill="#263E00" />
          <defs>
            <linearGradient
              id="paint0_linear_123_14419"
              x1="12"
              y1="4"
              x2="12"
              y2="20"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FF8639" />
              <stop offset="1" stop-color="#8FEC51" />
            </linearGradient>
          </defs>
        </SVGIconRender>
  );
};

export default TaskModule;
